var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.patientData)?_c('v-tab-item',{attrs:{"value":"impfempfehlungen"}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card',{staticClass:"mb-2"},[_c('v-card-title',[_vm._v("e-Impfpass")])],1)],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }